module.exports = __webpack_public_path__ + "static/marcos_inacio-c3b4b5b52c74619325d5f01d463b0213.png";